<template>
  <el-card shadow="never">
    <template slot="header">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'Facility Finance revision'}">
          {{ $root.getHeader() }} Wallet Detail
        </el-breadcrumb-item>
    </el-breadcrumb>
    </template>
    <el-table @row-click="routeToCustomer" :data="data" v-loading="loading">
      <el-table-column label="Customer" prop="customer.company"></el-table-column>
      <el-table-column
        label="Balance"
        prop="balanceAmount"
        :formatter="(_row, _column, cellValue) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      >
      </el-table-column>
      <el-table-column
        label="Active Lease"
        prop="activeLease"
        :formatter="(_row, _column, cellValue) => cellValue === true ? 'Yes' : 'No'"
      ></el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';

export default {
  name: 'WalletDetail',
  props: {
    facility: { required: true, type: String },
  },
  data() {
    return {
      loading: false,
      data: [],
    };
  },
  watch: {
    async facility() {
      await this.getWalletDetail();
    },
  },
  async mounted() {
    await this.getWalletDetail();
  },
  methods: {
    routeToCustomer(row) {
      const customerId = row.customer ? row.customer._id : row.customer;

      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: customerId, facility: this.facility } });
        return;
      }
      this.$router.push({ name: 'Customer', params: { id: customerId } });
    },
    async getWalletDetail() {
      this.loading = true;
      const response = await axios.get(
        `${ADMIN_API_BASE}/facilities/${this.facility}/wallet/detail`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        },
      );

      this.data = response.data;
      this.loading = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/WalletDetail.vue